<template>
	<b-container fluid>
		<b-card
			class="m-4"
			header="Excluir autorizações em lote"
			header-text-variant="white"
			header-tag="header"
			header-bg-variant="success"
			footer-tag="footer"
		>
			<b-card-text>
				<b-form>
					<b-row>
						<b-col>
							<b-form-group
								id="tipo-refeicao-form-group"
								label="Tipo de autorização"
								label-for="tipo-refeicao"
							>
								<b-form-select
									id="tipo-refeicao"
									name="tipo-refeicao"
									:state="
										$v.autorizacao.$error ? false : null
									"
									v-model="autorizacao"
									class="mb-3"
									aria-describedby="tipo-refeicao-feedback"
									@change="atualizaTabela"
								>
									<template v-slot:first>
										<b-form-select-option
											:value="null"
											disabled
											>-- Selecione o tipo de refeição
											--</b-form-select-option
										>
									</template>
									<b-form-select-option
										v-for="autorizacao in autorizacoes"
										:key="autorizacao.id"
										:value="autorizacao.id"
										>{{
											autorizacao.tipoderefeicao.descricao
										}}</b-form-select-option
									>
								</b-form-select>

								<b-form-invalid-feedback
									id="tipo-refeicao-feedback"
									>Escolha um tipo de
									refeição.</b-form-invalid-feedback
								>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col class="d-flex">
							<label class="mr-2">Filtro:</label>
							<b-form-input v-model="filtro"></b-form-input>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<b-table
								id="tabela-acompanhantes"
								:fields="campos_tabela"
								:items="acompanhantes"
								:per-page="perPage"
								:current-page="currentPage"
								:filter="filtro"
								:filterIncludedFields="[]"
								@filtered="onFiltered"
								:tbody-tr-class="rowClass"
								@row-clicked="onRowSelected"
								small
							></b-table>
						</b-col>
					</b-row>
					<b-row align-h="center">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							aria-controls="tabela-acompanhantes"
						></b-pagination>
					</b-row>
				</b-form>
			</b-card-text>
			<template v-slot:footer>
				<b-button variant="success" @click="excluir"
					>Excluir autorizações</b-button
				>
			</template>
		</b-card>
	</b-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import mixinToast from "@/mixins/mixinToast.js";

export default {
	mixins: [mixinToast],
	data() {
		return {
			leitosSelecionados: [],
			autorizacoes: null,
			autorizacao: null,
			acompanhantesSelecionados: [],
			filtro: "",
			currentPage: 1,
			totalRows: 0,
			perPage: 10,
			tiposRefeicao: null,
			tipoRefeicao: null,
			acompanhantes: null,
			campos_tabela: [
				{ key: "num_cra", label: "Crachá" },
				{ key: "nome_acompanhante", label: "Acompanhante" },
				{ key: "nome_paciente", label: "Paciente" },
				{ key: "lto_lto_id", label: "Leito" },
			],
		};
	},
	methods: {
		atualizaTabela() {
			this.$http
				.get(
					`/cracharefeicaoporautorizacao?autorizacao_id=${this.autorizacao}`
				)
				.then((result) => {
					this.acompanhantes = result.data;
					this.leitosSelecionados = [];
					this.acompanhantesSelecionados = [];
					this.totalRows = this.acompanhantes.length;
				});
		},
		excluir() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$http
					.post(
						"/excluicracharefeicaoemlote",
						this.acompanhantesSelecionados
					)
					.then((result) => {
						this.exibeToast(
							result.data.success,
							result.data.message
						);
						this.atualizaTabela();
					});
			}
		},
		getTiposRefeicao() {
			this.$http.get("/tipoderefeicao").then((response) => {
				this.tiposRefeicao = response.data;
			});
		},
		getAutorizacoesDoDia() {
			this.$http.get("/autorizacoesdodia").then((result) => {
				this.autorizacoes = result.data;
			});
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		onRowSelected(item) {
			const indice = this.leitosSelecionados.indexOf(item.id);
			if (indice != -1) {
				this.leitosSelecionados.splice(indice, 1);
				this.acompanhantesSelecionados.splice(indice, 1);
			} else {
				this.leitosSelecionados.push(item.id);
				this.acompanhantesSelecionados.push(item.id);
			}
		},
		rowClass(item, type) {
			if (
				this.leitosSelecionados.indexOf(item.id) != -1 &&
				type === "row"
			) {
				return "table-primary";
			}
			return;
		},
	},
	validations: {
		autorizacao: {
			required,
		},
	},
	mounted() {
		this.getAutorizacoesDoDia();
	},
};
</script>

<style></style>
